import { slug } from '../../core/helpers';

const createCommunityUrl = (id, name, forOwner) => `/communities/${id}/${slug(name)}${forOwner && '?forOwner=true'}`;

export default createCommunityUrl;
